import React from 'react'

import { Button } from '@material-ui/core/'

class InviteInternal extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      sent: false
    }
  }

  inviteInternalSend = e => {
    e.preventDefault()

    this.props.sendInternalInvite(this.props.aid, this.props.fid)

    this.setState((state, props) => ({
      sent: true
    }))
  }

  render() {
    const { sent } = this.state

    return (
      <span className="invite-internal">
        <span className="invite-name">
          {this.props.firstName} {this.props.lastName}
        </span>
        <span className="invite-cookn-user">Cook'n User</span>
        <Button
          variant="contained"
          color="primary"
          className="invite-tag"
          href="#"
          onClick={e => {
            this.inviteInternalSend(e)
          }}
          disabled={sent}
        >
          Add +
        </Button>
      </span>
    )
  }
}

export default InviteInternal



// WEBPACK FOOTER //
// ./src/Components/InviteInternal.js